import { render, staticRenderFns } from "./NewIncomeDocumentPage.vue?vue&type=template&id=61fe3ca3&scoped=true"
import script from "./NewIncomeDocumentPage.vue?vue&type=script&lang=js"
export * from "./NewIncomeDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fe3ca3",
  null
  
)

export default component.exports